import React, { useEffect, useRef, useState } from 'react';
import { Container } from './styles'
import LogoHeader from '../../assets/images/onfarm-logo-branca.png'
import LogoRuminaColorido from '../../assets/images/rumina-logo-escura.png'
import { ErrorMessage, Field, Formik } from 'formik';
import { ContentContainer } from '../../components/Base';
import { ButtonActionBack, ButtonSelectFarm, ContainerFarmsSelects, Form, FormControl, ImgIconBack, InputError, } from '../../assets/styles/GlobalStyles';
import { getMe, accessFarmUser, getListFarmUser, getListFarmUserSearchFarmName } from '../../services/services';
import { createCookieFarm } from '../../utils/cookies';
import IconBack from '../../assets/icon/icon-back.svg';
import { InputSearch } from "../../components/Base/Elements/InputSearch";
import LoadingCircle from '../../components/LoadingCircle/loading-circle';
import { sanitizeID } from "../../utils/sanitize";
import { changeLanguage, getCurrentLanguage } from '../../i18n/locale'
import { translate } from '../../i18n/index';

const SelectFarm = ({ history }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [farms, setFarms] = useState([]);
    const [loading, setLoading] = useState(true)
    const [farmsFiltered, setFarmsFiltered] = useState([]);
    const [farmSelected, setFarmSelected] = useState({});
    const [valueInputSearch, setValueInputSearch] = useState('');
    const idTimeoutRef = useRef(null);

    useEffect(() => {
        checkCurrentUserFarm();
    }, []);

    // useEffect(() => {
    //     setFarmsFiltered([])
    //     const timeOutId = setTimeout(() => setFarmsFiltered(farms.filter((item) => item.name.toLowerCase().includes(valueInputSearch.toLowerCase()))), 1000);
    //     return () => clearTimeout(timeOutId);
    // }, [farms, valueInputSearch]);

    const checkCurrentUserFarm = async (paramPage, paramFarmName = null) => {
        const userResponse = await getMe();
        const user = userResponse?.data;

        if (user.languageMain) {
            changeLanguage(user.languageMain)
        }

        let objectToSave = {
            ...user,
            farmUsers: []
        };


        if (paramFarmName === null) {

            let countGet = 1;
            let objCompleto = [];

            do {

                const aux000 = await getListFarmUser(user.id, countGet) ?? [];

                if (aux000.length > 0 && countGet < 2) {
                    objCompleto = objCompleto.concat(aux000);
                    countGet++;
                }
                else {
                    countGet = 0;
                }

            } while (countGet > 0)

            objectToSave.farmUsers = objCompleto;

        }
        else {
            objectToSave.farmUsers = await getListFarmUserSearchFarmName(user.id, paramPage == null ? 1 : paramPage, paramFarmName);
        }

        setCurrentUser(user);
        let farmData = [];
        if (objectToSave.farmUsers.length) {
            objectToSave.farmUsers.map((farmUser) => farmData.push({
                'name': farmUser.farm.name,
                'id': farmUser.farm.id,
                'apiKeyId': farmUser.farm.apiKeyId,
                'customerId': farmUser.farm?.customer?.id,
                'customerName': farmUser.farm?.customer?.name,
                'farmUserId': sanitizeID(farmUser['@id']),
            }));
        }
        setFarms(farmData);
        setFarmsFiltered(farmData);
        setLoading(false)

    };

    function handleClickSelectFarm(value) {
        setFarmSelected({ ...value, language: getCurrentLanguage() });
    }

    function compare(a, b) {
        if (a.name > b.name) {
            return 1
        }
        if (a.name < b.name) {
            return -1
        }
        return 0
    }

    const search = (text) => {
        window.clearTimeout(idTimeoutRef.current);

        if (text !== '') {
            idTimeoutRef.current = setTimeout(async () => {
                setLoading(true);
                await checkCurrentUserFarm(1, text);
            }, 1000);
        } else {
            setLoading(true);
            checkCurrentUserFarm();
        }
    }

    return (
        <Container>
            <div className='headerSelectFarm'>
                <div>
                    <ButtonActionBack onClick={() => history.goBack()} type="button">
                        <ImgIconBack src={IconBack} className="icon-back" alt="Button Back" />{translate('buttonActionBack')}
                    </ButtonActionBack>
                </div>
                <img src={LogoHeader} alt="icone de seta para baixo" />
            </div>
            <div className='contentSelectFarm'>
                <div>
                    <div className='contentSelectFarmText'>
                        <span>{translate('labelBemVindo')}(a) {currentUser ? currentUser.name : '... '},</span>
                        <span>{translate('labelSelecioneFazendaAvancar')}</span>
                    </div>
                    <div className='contentSelectFarmList'>
                        <ContentContainer>
                            {farms && (
                                <Formik
                                    enableReinitialize
                                    initialValues={{
                                        farm: '',
                                    }}
                                    onSubmit={async (values, actions) => {
                                        if (farmSelected) {
                                            try {
                                                createCookieFarm(farmSelected);
                                                await accessFarmUser(farmSelected.farmUserId);
                                                window.location = `${process.env.REACT_APP_WEB_URL}`;

                                                // history.push({
                                                //     pathname: '/selecionar-categoria',
                                                //     search: history.location.search,
                                                //     state: { farmSelected: farmSelected }
                                                // })
                                            } catch (e) {
                                                console.error('Invalid Farm', e.message)
                                            }
                                        }
                                    }}>
                                    {({ isSubmitting }) => (
                                        <Form>
                                            <FormControl>
                                                <Field
                                                    name="search"
                                                    key="search-farm"
                                                    placeholder={translate('inputSearchFarm')}
                                                    onChange={(e) => {
                                                        search(e.target.value);
                                                        setValueInputSearch(e.target.value);
                                                    }}
                                                    value={valueInputSearch}
                                                    component={InputSearch}
                                                />
                                                <ErrorMessage name="search" component={InputError} />
                                            </FormControl>
                                            <ContainerFarmsSelects>
                                                {loading && <LoadingCircle />}
                                                {!loading && farmsFiltered.sort(compare).map((farm, index) => (
                                                    <FormControl key={farm.id + '-filtered-' + farm.farmUserId}>
                                                        <ButtonSelectFarm name="farm" onClick={() => handleClickSelectFarm(farm)} key={index + '-' + farm.name + '-filtered'} type="submit">
                                                            {farm.name}
                                                        </ButtonSelectFarm>
                                                    </FormControl>
                                                ))

                                                }
                                            </ContainerFarmsSelects>
                                        </Form>
                                    )}
                                </Formik>
                            )}
                        </ContentContainer>
                    </div>
                </div>
            </div>
            <div className='footerSelectFarm'>
                <img src={LogoRuminaColorido} alt="icone de seta para baixo" />
            </div>
        </Container>
    );
};

export default SelectFarm;
